import { useState, useCallback } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { SHORTCUTS } from "./shortcuts";

const useCommandPalette = () => {
  const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);

  const openCommandPalette = useCallback(() => setIsCommandPaletteOpen(true), []);
  const closeCommandPalette = useCallback(() => setIsCommandPaletteOpen(false), []);

  useHotkeys(SHORTCUTS.TOGGLE_PALETTE.keys, () => setIsCommandPaletteOpen((prev) => !prev), {
    enableOnFormTags: true,
    preventDefault: true,
  });

  return { isCommandPaletteOpen, openCommandPalette, closeCommandPalette };
};

export default useCommandPalette;
